module.exports = __webpack_public_path__ + "img/404.0c1a1967.png";